import { useMutation, useQueryClient } from "@tanstack/react-query";
import api from "../api";

export interface MergeTicketsPayload {
  parent_ticket_id: number;
  child_ticket_ids: number[];
}

export interface MergeTicketsResponse {
  statusCode: number;
  message: string;
}

const mergeTickets = async (
  payload: MergeTicketsPayload
): Promise<MergeTicketsResponse> => {
  const { data } = await api.post<MergeTicketsResponse>(
    "/tickets/merge/v1",
    payload
  );
  return data;
};

export const useMergeTickets = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: mergeTickets,
    onSuccess: () => {
      // Invalidate tickets queries to refresh the data
      queryClient.invalidateQueries({ queryKey: ["tickets"] });
    },
  });
};
